<template>
  <b-row v-if="isShowBreadcrumb" class="content-header">
    <!-- Content Left -->
    <b-col class="content-header-left mb-2" cols="12" :md="breadcrumbColMd">
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb>
              <b-breadcrumb-item
                v-if="!$route.meta.hiddenBreadcrumbList"
                :to="breadcrumbHomePath"
              >
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col
      v-if="
        getIsShowAutoRefresh &&
        ![
          'internalPortalDashboard',
          'internalPortalExecutiveDashboard',
          'internalSiteAccessDashboard',
        ].includes(currentName)
      "
      class="content-header-right text-md-right d-md-flex d-none mb-2 justify-content-end align-items-center"
      :md="12 - breadcrumbColMd"
      cols="12"
    >
      <div class="content-header-switch">
        <atom-switch
          v-model="isEnableAutoRefresh"
          title="Auto Refresh"
          titleDirection="left"
        ></atom-switch>
      </div>
    </b-col>

    <b-col
      v-if="getShowVeeam"
      class="content-header-right text-md-right d-flex mb-2 pr-3 justify-content-md-end justify-content-start align-items-center"
      :md="12 - breadcrumbColMd"
      cols="12"
    >
      <b-tooltip
        v-if="!getVeeamStatus"
        :target="'alert-veeam-connection'"
        placement="left"
        boundary="window"
        variant="danger"
      >
        {{ getCurrentServerVeeam.name }} connection loss
      </b-tooltip>
      <div :id="'alert-veeam-connection'">
        <feather-icon
          v-if="isEmptyString(currentVeeamServer.id)"
          icon="AlertCircleIcon"
          size="18"
          class="align-text-top mr-1 text-danger stroke-current"
        />
      </div>
      <div class="content-header-switch w-100">
        <atom-select
          placeholder="Select Veeam"
          label="name"
          :option="getAllVeeamServer"
          v-model="currentVeeamServer"
          :isAppendToBody="false"
          :isEnableProper="false"
          :isClearable="false"
        ></atom-select>
      </div>
    </b-col>

    <b-col
      v-if="
        currentModule === 'webPortal' &&
        currentMode === 'internal' &&
        ![
          'internalPortalDashboard',
          'internalPortalExecutiveDashboard',
          'internalSiteAccessDashboard',
        ].includes(currentName)
      "
      class="content-header-right text-lg-right d-lg-flex mb-2 justify-content-end align-items-center"
      :lg="12 - breadcrumbColMd"
      cols="12"
    >
      <site-select @onSelectSite="openModalSiteSelect"></site-select>
    </b-col>

    <b-col
      v-if="
        currentModule === 'webPortal' &&
        currentMode === 'internal' &&
        getIsShowAutoRefresh
      "
      class="mb-2 d-flex justify-content-md-end justify-content-start align-items-center"
      :lg="12 - breadcrumbColMd"
      cols="12"
    >
      <div class="d-none d-sm-block" style="min-width: 160px">
        <atom-switch
          v-model="isEnableAutoRefresh"
          title="Auto Refresh"
          titleDirection="left"
        ></atom-switch>
      </div>

      <div class="flex-fill">
        <site-select @onSelectSite="openModalSiteSelect"></site-select>
      </div>
    </b-col>

    <modal-site-select
      v-if="currentModule === 'webPortal' && currentMode === 'internal'"
      :modalId="modalSiteSelectId"
    />
  </b-row>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BTooltip,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import { mapActions, mapGetters } from "vuex"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import ModalSiteSelect from "@/layouts/components/selectSiteAccess/ModalSiteSelect.vue"
import SiteSelect from "@/layouts/components/selectSiteAccess/SiteSelect.vue"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BTooltip,
    AtomSwitch,
    AtomSelect,
    ModalSiteSelect,
    SiteSelect,
  },
  mixins: [mixinsValidator],
  data() {
    return {
      currentVeeamServer: "",
      breadcrumbColMd: 9,
      autoRefreshState: true,
      modalSiteSelectId: "modal-site-select",
    }
  },
  computed: {
    ...mapGetters("app", [
      "getCurrentStatusAutoRefresh",
      "getCurrentServerVeeam",
      "getShowVeeam",
      "getAllVeeamServer",
      "getVeeamStatus",
    ]),
    ...mapGetters("appAutoRefresh", [
      "getIsShowAutoRefresh",
      "getWPMExecutiveDashboardAutoRefresh",
      "getWPMDashboardAutoRefresh",
      "getWPMSiteAccessDashboardAutoRefresh",
      "getSMSDashboardAutoRefresh",
      "getBMMDashboardAutoRefresh",
      "getNCMDashboardAutoRefresh",
    ]),
    isShowBreadcrumb() {
      return (
        !this.$route.meta.hiddenBreadcrumb &&
        (this.$route.meta.breadcrumb || this.$route.meta.pageTitle)
      )
    },
    breadcrumbHomePath() {
      this.$route.meta.module === "backupManagement" &&
      this.$route.meta.pageTitle !== "Dashboard"
        ? (this.breadcrumbColMd = 8)
        : (this.breadcrumbColMd = 9)
      return this.$route.meta.type === "internal" ? "/internal" : "/"
    },
    currentName() {
      return this.$route.name
    },
    currentModule() {
      return this.$route.meta.module
    },
    currentMode() {
      return this.$route.meta.type
    },
    isEnableAutoRefresh: {
      get() {
        return this.autoRefreshState
      },
      set(value) {
        if (this.currentModule === "webPortal") {
          if (this.currentName === "internalPortalDashboard") {
            this.setWPMDashboardAutoRefresh(value)
          } else if (this.currentName === "internalPortalExecutiveDashboard") {
            this.setWPMExecutiveDashboardAutoRefresh(value)
          } else if (this.currentName === "internalSiteAccessDashboard") {
            this.setWPMSiteAccessDashboardAutoRefresh(value)
          }
        } else if (this.currentModule === "serverManagement") {
          this.setSMSDashboardAutoRefresh(value)
        } else if (this.currentModule === "backupManagement") {
          this.setBMMDashboardAutoRefresh(value)
        } else if (this.currentModule === "networkConfiguration") {
          this.setNCMDashboardAutoRefresh(value)
        }
      },
    },
  },
  watch: {
    getCurrentServerVeeam() {
      this.currentVeeamServer = this.getCurrentServerVeeam
    },

    currentVeeamServer() {
      this.setCurrentVeeamServer(this.currentVeeamServer)
    },

    currentModule: {
      deep: true,
      handler() {
        if (this.currentModule === "webPortal") {
          if (this.currentName === "internalPortalDashboard") {
            let autoRefresh = localStorage.getItem("wpm-dashboard-auto-refresh")
            let isEnableAutoRefresh = autoRefresh === "true"
            if (autoRefresh) {
              this.autoRefreshState = isEnableAutoRefresh
            } else {
              this.autoRefreshState = this.getWPMDashboardAutoRefresh
            }
            this.setWPMDashboardAutoRefresh(isEnableAutoRefresh)
          } else if (this.currentName === "internalPortalExecutiveDashboard") {
            let autoRefresh = localStorage.getItem(
              "wpm-executive-dashboard-auto-refresh"
            )
            let isEnableAutoRefresh = autoRefresh === "true"
            if (autoRefresh) {
              this.autoRefreshState = isEnableAutoRefresh
            } else {
              this.autoRefreshState = this.getWPMExecutiveDashboardAutoRefresh
            }
            this.setWPMExecutiveDashboardAutoRefresh(isEnableAutoRefresh)
          } else if (this.currentName === "internalSiteAccessDashboard") {
            let autoRefresh = localStorage.getItem(
              "wpm-site-access-dashboard-auto-refresh"
            )
            let isEnableAutoRefresh = autoRefresh === "true"
            if (autoRefresh) {
              this.autoRefreshState = isEnableAutoRefresh
            } else {
              this.autoRefreshState = this.getWPMSiteAccessDashboardAutoRefresh
            }
            this.setWPMSiteAccessDashboardAutoRefresh(isEnableAutoRefresh)
          }
        } else if (this.currentModule === "serverManagement") {
          let autoRefresh = localStorage.getItem("sms-dashboard-auto-refresh")
          let isEnableAutoRefresh = autoRefresh === "true"
          if (autoRefresh) {
            this.autoRefreshState = isEnableAutoRefresh
          } else {
            this.autoRefreshState = this.getSMSDashboardAutoRefresh
          }
          this.setSMSDashboardAutoRefresh(isEnableAutoRefresh)
        } else if (this.currentModule === "backupManagement") {
          let autoRefresh = localStorage.getItem("bmm-dashboard-auto-refresh")
          let isEnableAutoRefresh = autoRefresh === "true"
          if (autoRefresh) {
            this.autoRefreshState = isEnableAutoRefresh
          } else {
            this.autoRefreshState = this.getBMMDashboardAutoRefresh
          }
          this.setBMMDashboardAutoRefresh(isEnableAutoRefresh)
        } else if (this.currentModule === "networkConfiguration") {
          let autoRefresh = localStorage.getItem("ncm-dashboard-auto-refresh")
          let isEnableAutoRefresh = autoRefresh === "true"
          if (autoRefresh) {
            this.autoRefreshState = isEnableAutoRefresh
          } else {
            this.autoRefreshState = this.getNCMDashboardAutoRefresh
          }
          this.setNCMDashboardAutoRefresh(isEnableAutoRefresh)
        }
      },
    },
  },
  methods: {
    ...mapActions("app", ["setCurrentVeeamServer"]),
    ...mapActions("appAutoRefresh", [
      "setWPMDashboardAutoRefresh",
      "setWPMExecutiveDashboardAutoRefresh",
      "setWPMSiteAccessDashboardAutoRefresh",
      "setSMSDashboardAutoRefresh",
      "setBMMDashboardAutoRefresh",
      "setNCMDashboardAutoRefresh",
    ]),

    openModalSiteSelect() {
      this.$bvModal.show(this.modalSiteSelectId)
    },
  },
}
</script>
<style lang="scss" scoped>
.content-header-switch {
  margin-right: -12px;
}
</style>
